export default __webpack_public_path__ + "static/media/flag21.3fbd3fa6.png";